import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const periodicAuditTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Periodic Audit',
  key: 'periodicAuditTemplate',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['NAME', 'description', '$empty'],
          ['schedule', '$empty', '$empty'],
          ['CAUDTIME', '$empty', '$empty'],
          ['occurs', '$empty', '$empty'],
          ['sunday', 'monday', 'tuesday'],
          ['wednesday', 'thursday', 'friday'],
          ['saturday', '$empty', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      NAME: {
        label: 'Name',
        type: 'text',
        initial: '',
        options: [],
        validation: {
          required: true,
        },
      },
      description: {
        label: 'Description',
        type: 'text',
        initial: '',
        options: [],
        validation: {
          required: false,
        },
      },
      CAUDTIME: {
        label: 'Start Time',
        type: 'text',
        initial: '',
        validation: {
          required: false,
          validators: [
            {
              type: 'length',
              length: 164,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/:'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      schedule: {
        type: 'custom',
        initial: 'Schedule',
        customComponent: 'schedule',
        className: 'section-label',
      },
      sunday: {
        type: 'checkbox',
        label: 'Sunday',
        initial: false,
        hide: 'false',
        validation: {
          required: false,
        },
      },
      monday: {
        type: 'checkbox',
        label: 'Monday',
        initial: false,
        hide: 'false',
        validation: {
          required: false,
        },
      },
      tuesday: {
        type: 'checkbox',
        label: 'Tuesday',
        initial: false,
        hide: 'false',
        validation: {
          required: false,
        },
      },
      wednesday: {
        type: 'checkbox',
        label: 'Wednesday',
        initial: false,
        hide: 'false',
        validation: {
          required: false,
        },
      },
      thursday: {
        type: 'checkbox',
        label: 'Thursday',
        initial: false,
        hide: 'false',
        validation: {
          required: false,
        },
      },
      friday: {
        type: 'checkbox',
        label: 'Friday',
        initial: false,
        hide: 'false',
        validation: {
          required: false,
        },
      },
      saturday: {
        type: 'checkbox',
        label: 'Saturday',
        initial: false,
        hide: 'false',
        validation: {
          required: false,
        },
      },
      occurs: {
        type: 'custom',
        initial: 'Occurs Every Week on',
        customComponent: 'schedule',
      },
    },
  },
};
